import React from "react";
import FlowDisplay from "./FlowDisplayer.js";
export default function HorizontalListComponent(props) {
    const { component, componentsList, form, onChange } = props;
    const childComponents = component.list.map((id) => componentsList[id]);
    return (React.createElement("div", { id: component.id, className: "horizontal-list-flow-component " +
            (props.isOutlined ? "flow-component-outlined" : "") },
        React.createElement(FlowDisplay, { outlinedComponent: "", components: childComponents, componentsList: componentsList, inputState: form, onChange: onChange })));
}
